export const links = [
    {
        name: 'Monetize',
        links: [
            {
                name: 'Overview',
                path: 'https://www.ironsrc.com/monetize/'
            },
            {
                name: 'Mediation',
                path: 'https://www.ironsrc.com/mediation/'
            },
            {
                name: 'Ad Monetization A/B Testing',
                path: 'https://www.ironsrc.com/monetization-ab-testing/'
            },
            {
                name: 'LevelPlay In-App Bidding',
                path: 'https://www.ironsrc.com/in-app-bidding/'
            },
            {
                name: 'Cross Promotion',
                path: 'https://www.ironsrc.com/cross-promotion/'
            },
            {
                name: 'ironSource App',
                path: 'https://www.ironsrc.com/platform-app/'
            },
            {
                name: 'Offerwall',
                path: 'https://www.ironsrc.com/offerwall/'
            },
            {
                name: 'Knowledge Center',
                path: 'https://developers.ironsrc.com/'
            }
        ]
    },
    {
        name: 'Advertise',
        links: [
            {
                name: 'Overview',
                path: 'https://www.ironsrc.com/advertise/'
            },
            {
                name: 'Playworks Studio',
                path: 'https://www.ironsrc.com/playworks-studio/'
            },
            {
                name: 'ROAS Optimizer',
                path: 'https://www.ironsrc.com/roas-optimizer/'
            },
            {
                name: 'Ad Revenue Measurement',
                path: 'https://www.ironsrc.com/user-level-ad-revenue/'
            }
        ]
    },
    {
        name: 'Resource Hub',
        links: [
            {
                name: 'LevelUp',
                path: 'https://www.ironsrc.com/levelup/'
            },
            {
                name: 'Blog',
                path: 'https://www.ironsrc.com/levelup/blog/'
            },
            {
                name: 'Podcast',
                path: 'https://www.ironsrc.com/levelup/podcast/'
            },
            {
                name: 'Videos',
                path: 'https://www.ironsrc.com/levelup/videos/'
            },
            {
                name: 'Case Studies',
                path: 'https://www.ironsrc.com/levelup/case-studies/'
            },
            {
                name: 'eBooks',
                path: 'https://www.ironsrc.com/levelup/ebooks/'
            },
            {
                name: 'Glossary',
                path: 'https://www.ironsrc.com/glossary/'
            },
            {
                name: 'Testimonials',
                path: 'https://www.ironsrc.com/testimonials/'
            }
        ]
    },
    {
        name: 'About ironSource',
        links: [
            {
                name: 'About',
                path: 'http://company.ironsrc.com/about'
            },
            {
                name: 'Newsroom',
                path: 'https://company.ironsrc.com/newsroom/'
            },
            {
                name: 'Events',
                path: 'https://company.ironsrc.com/newsroom/events/'
            },
            {
                name: 'Terms of use',
                path: 'https://www.ironsrc.com/terms-of-use/'
            },
            {
                name: 'Privacy Policy',
                path: 'https://www.ironsrc.com/privacy-policy/'
            },
            {
                name: 'Modern Slavery Statement',
                path: 'https://static.ironsrc.com/wp-content/uploads/2019/07/modern-slavery-statement.pdf'
            }
        ]
    }
];
